import React from 'react';

const Door = ({ className }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <title>Page 1</title>
        <g fill="#4A4A4A" fillRule="evenodd">
            <path d="M15 19.5h-4V4c0-.212-.134-.402-.335-.472L3.442 1H15v18.5zm-5 0v3.296L3.442 20.5 1 19.645V1.205l9 3.15V19.5zM15.5 0H.5L.482.004C.422.005.362.017.31.038l-.016.01L.21.09.164.136.14.157C.1.197.07.243.046.294l-.012.03C.015.38 0 .44 0 .5V20c0 .063.015.12.035.177l.025.05.068.1.04.042.106.07.044.023.017.01 10 3.5c.053.018.11.027.165.027.102 0 .204-.03.29-.093.132-.093.21-.245.21-.407v-3h4.5c.277 0 .5-.224.5-.5V.5c0-.276-.223-.5-.5-.5z" />
            <path d="M7.5 16c.276 0 .5-.255.5-.57v-2.86c0-.314-.224-.57-.5-.57s-.5.256-.5.57v2.86c0 .315.224.57.5.57" />
        </g>
    </svg>
);

Door.displayName = 'Door';

/**
 * Door Functional Component.
 */
export default Door;
